import { render, staticRenderFns } from "./SspIncentive.vue?vue&type=template&id=6f20ef0d&"
import script from "./SspIncentive.vue?vue&type=script&lang=js&"
export * from "./SspIncentive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports